export const initialState = () => ({
  optionsFilterAdditionalServices: [],
  listAdditionalServices: [],
  paginationListAdditionalServices: {},
  modalConfirmNoAdditionalServices: false,
  modalConfirmMaxItens: false,

  filterName: null
})
